import styled from "@emotion/styled";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const getSmallFieldStyles = (hasSmallField) =>
    hasSmallField
        ? {
              "& > div.MuiInputBase-root": {
                  height: 30,
                  padding: "5px",
                  width: 260,
              },
              "& .MuiPickersInputBase-root": {
                  height: 30,
                  fontSize: 12,
              },
              "& input": {
                  fontSize: 12,
                  lineHeight: "10px",
                  padding: "2px 8px !important",
                  position: "relative",
                  top: "-5px",
              },
              "& label": {
                  fontSize: 12,
                  top: "-8px",
                  "&.Mui-focused": { top: 0 },
                  "&.MuiFormLabel-filled": { top: 0 },
              },
          }
        : {};

export const StyledDatePicker = styled(DatePicker)(({ hasSmallField }) => getSmallFieldStyles(hasSmallField));

export const StyledDateTimePicker = styled(DateTimePicker)(({ hasSmallField }) => getSmallFieldStyles(hasSmallField));
